<div class="chat-edit-form" [formGroup]="form">
  <app-photo
    class="chat-edit-form__avatar"
    [mode]="'edit'"
    [type]="'chat'"
    [id]="data?.isAvatarExists ? data?.chatId : undefined"
    [height]="isLargeScreen ? '144px' : '96px'"
    [width]="isLargeScreen ? '144px' : '96px'"
    [borderRadius]="isLargeScreen ? '144px' : '96px'"
    [rounded]="true"
    [loading]="loading"
    (photoChange)="onPhotoChange($event)"
  ></app-photo>

  <tui-input
    class="field"
    tabindex="1"
    formControlName="chatName"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [tuiTextfieldSize]="tuiElementLargeSize"
  >
    {{ 'components.chatEditForm.fields.chatName' | translate }}

    <span class="tui-required"></span>
    <input tuiTextfieldLegacy appTestingId="Input.chatName" />
  </tui-input>

  <tui-input
    class="field"
    tabindex="2"
    formControlName="chatDescription"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [tuiTextfieldSize]="tuiElementLargeSize"
  >
    {{ 'components.chatEditForm.fields.chatDescription' | translate }}

    <input tuiTextfieldLegacy appTestingId="Input.chatDescription" />
  </tui-input>

  <app-field-wrapper
    [text]="'components.chatEditForm.fields.onlyForAdmins' | translate"
    [size]="tuiElementMediumSize"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
  >
    <app-toggle tabindex="3" formControlName="onlyForAdmins" [size]="tuiElementMediumSize"></app-toggle>
  </app-field-wrapper>

  <div class="chat-edit-form__buttons">
    <button
      tuiButton
      appearance="secondary"
      type="button"
      [size]="tuiElementLargeSize"
      [disabled]="loading"
      (click)="cancel()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>

    <button tuiButton type="button" [size]="tuiElementLargeSize" [disabled]="loading" (click)="apply()">
      {{ 'common.buttons.save' | translate }}
    </button>
  </div>
</div>
